import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cryptoJS from 'crypto-js';
import { history } from 'routes/history';
import { FormattedText, formatText } from 'core/i18n';
import { LOAN } from 'constants/userProfile';
import { ALLOW_COOKIE, BASE_PATH, PUBLICA_URL } from 'constants/index';
import UtagHelper from 'utilities/utagHelper';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Header } from 'components/header/header';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { recordPageError } from 'utilities/uTagging';
import preLoaderActions from 'actions/preLoaderActions';
import Storage from 'utilities/storage';

class ErrorsView extends Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        const { name, isAres, dossierFailStatusCode } = this.props.userProfile;
        const initialOnboardingRequestFailure = this.props.userProfile.initialOnboardingRequestFailure;
        if (
            typeof name === 'undefined' &&
            typeof initialOnboardingRequestFailure === 'undefined' &&
            !isAres &&
            !dossierFailStatusCode
        ) {
            history.push(`${BASE_PATH}`);
        }
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const { preLoaderActions, userProfile, errorState } = this.props;
        const { errorCode, errorNumber, pageName } = errorState;
        const errorType = userProfile.errorType;
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

        recordPageError({
            pageName,
            description: formatText(this.getErrorMessage()),
            onboardingHolderType: JointHolderInfo.typeHolder === 'primer titular' ? 'firstTitular' : 'secondTitular',
            investmentType: userProfile.investmentType,
            identificadorOnboarding: docNumberEncrypted,
            errorStatus: errorCode,
            errorNumber,
        });

        if (ALLOW_COOKIE) {
            if (Storage.cookies.get('accessToken')) {
                Storage.cookies.remove('accessToken');
            }

            if (Storage.cookies.get('refreshToken')) {
                Storage.cookies.remove('refreshToken');
            }
        }

        preLoaderActions.hidePreLoader();
    }

    buttonAction = () => {
        const { action, userProfile } = this.props;
        if (userProfile.dossierFailStatusCode && userProfile.dossierFailStatusCode.toString() === '401') {
            return (window.location.href = `${PUBLICA_URL}prestamo-ares`);
        }
        action();
    };

    getDefaultContent = () => {
        const { userProfile, content } = this.props;

        return userProfile.investmentType === LOAN ? 'messagesScreen-defaultErrorContent_ares' : content;
    };

    getErrorMessage = () => {
        const { errorState } = this.props;

        return errorState.errorMessage ?? this.getDefaultContent();
    };

    getErrorContent = () => {
        const { errorState } = this.props;

        return errorState.errorContent ?? this.getDefaultContent();
    };

    render() {
        const { userProfile, title, subtitle, iconClass, buttonText, buttonClass, injectedContent } = this.props;

        const injectedContentValue = userProfile.injectedContentValue || injectedContent;

        return (
            <div>
                <Header titleClass="hidden" />
                <div className="main-container messages-main-container basic-layering">
                    <MessagesScreen
                        iconClass={
                            typeof userProfile.errorIconClass !== 'undefined' ? userProfile.errorIconClass : iconClass
                        }
                        title={typeof userProfile.errorTitle !== 'undefined' ? userProfile.errorTitle : title}
                        subtitle={
                            typeof userProfile.errorSubtitle !== 'undefined' ? userProfile.errorSubtitle : subtitle
                        }
                        buttonText={typeof userProfile.buttonText !== 'undefined' ? userProfile.buttonText : buttonText}
                        buttonClass={
                            typeof userProfile.buttonClass !== 'undefined' ? userProfile.buttonClass : buttonClass
                        }
                        action={this.buttonAction}
                    >
                        <FormattedText value={this.getErrorContent()} injectedStrings={injectedContentValue} />
                    </MessagesScreen>
                </div>
            </div>
        );
    }
}

ErrorsView.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    content: PropTypes.string,
    iconClass: PropTypes.string,
    action: PropTypes.func,
    buttonText: PropTypes.string,
    buttonClass: PropTypes.string,
    injectedContent: PropTypes.array,
};

ErrorsView.defaultProps = {
    title: formatText('messagesScreen-defaultErrorTitle'),
    subtitle: '',
    content: 'messagesScreen-defaultErrorContent',
    iconClass: 'icons icons--icon-warning',
    action: () => {
        window.location.href = PUBLICA_URL;
    },
    buttonText: formatText('button-understood'),
    buttonClass: 'form__button form__button-primary',
    injectedContent: [],
};

module.exports.constructor = ErrorsView;
module.exports.ErrorsView = connect(
    state => ({
        userProfile: state.userProfile,
        errorState: state.error,
    }),
    dispatch => ({
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(ErrorsView);
